import styled from 'styled-components'

interface IProps {
    statusColor: string
}

export const SystemAudytContentContainer = styled.div<IProps>`
    display: flex;
    min-width: 1023px;
    flex-direction: column;
    border: 1px solid ${({ theme }) => theme['gray-400']};
    border-left: 3px solid ${({ statusColor }) => statusColor};
    margin: 4px;

    &:hover {
        background: var(--gray-100);
    }

    .c-row {
        display: flex;
        flex-direction: row;
    }
    .c-column {
        display: flex;
        flex-direction: column;
    }

    .header {
        padding: 0px 8px;
        color: ${({ theme }) => theme['gray-800']};
        font-size: 12px;
        justify-content: space-between;
        .itens-align {
            align-self: center;
            padding: 16px 8px;
        }
        .date {
            min-width: 130px;
            width: 130px;
        }
        .description {
            /* min-width: 400px; */
            width: 360px;
            span {
                font-weight: 800;
            }
        }
        .status-name {
            width: 70px;
            color: ${({ statusColor }) => statusColor};
        }
        .method {
            width: 55px;
            color: ${({ theme }) => theme['gray-700']};
            font-weight: 700;
        }
        .plugin-name {
            width: 200px;
        }
        .endpoint {
            width: 300px;
        }
        .responsible {
            width: 180px;
            word-break: break-all;
        }
        .selection {
            cursor: pointer;
            color: ${({ theme }) => theme['gray-600']};
            font-size: 20px;
            padding: 0px 24px;
        }
    }
    .line-divisor {
        border-top: 1px solid ${({ theme }) => theme['gray-600']};
        margin: 0px 2% 0px 1%;
    }
    .width-100 {
        width: 100%;
    }

    .inner-content {
        .calendar {
            padding-top: 26px;
            padding-left: 10px;
            font-size: 11px;
            color: ${({ theme }) => theme['gray-800']};
            /* margin-left: 10px; */
            i {
                font-size: 20px;
                color: ${({ theme }) => theme['gray-700']};
            }
            .calendar-text {
                align-self: center;
                padding-left: 12px;
            }
        }
        .system-request-type-text {
            font-size: 12px;
            color: ${({ theme }) => theme['gray-800']};
            padding-left: 40px;
            font-weight: 600;
            .divisor {
                padding: 0px 16px;
                color: ${({ theme }) => theme['gray-400']};
                font-weight: 400;
            }
            .system-request-type-status {
                padding-right: 4px;
                color: ${({ statusColor }) => {
                    console.log('colorr->', statusColor)

                    return statusColor
                }};
                font-size: 12px;
                font-weight: 600;
            }
        }
        .body {
            padding: 16px;
            .horizontal-line {
                border-left: 2px solid ${({ theme }) => theme['gray-300']};
                margin-top: -32px;
            }
            .json-container {
                padding: 0px 16px;
            }
        }
    }
`
